import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=048ac3c8&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=048ac3c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048ac3c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048ac3c8')) {
      api.createRecord('048ac3c8', component.options)
    } else {
      api.reload('048ac3c8', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=048ac3c8&scoped=true&", function () {
      api.rerender('048ac3c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lxim1T9y6JHr/JS/comp/SearchFilterTokens.vue"
export default component.exports